export type NfcReadResult = NFCReadSuccess | NFCReadError;

export interface NFCReadSuccess {
  type: 'read';
  serialNumber: string;
  records: {
    id?: string;
    encoding?: string;
    data?: string;
    lang?: string;
    recordType:
      | 'absolute-url'
      | 'empty'
      | 'mime'
      | 'smart-poster'
      | 'text'
      | 'unknown'
      | 'URL';
  }[];

  timestamp: string;
}

export interface NFCReadError {
  type: 'error';
  error: string;
  timestamp: string;
}
